import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError, tokens } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PublicShell } from "@/pages/Privacy";

const MAIL = "info@imamogluas.com";

function InAppRequest() {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/account/deletion-request", { reason }); setDone(data); toast.success("Talebiniz alındı"); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  if (done) return <div className="rounded border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800" data-testid="deletion-request-done">Talebiniz alındı ({done.email}). Süper Yönetici onayından sonra hesabınız kapatılacaktır.</div>;
  return (
    <div className="space-y-2" data-testid="deletion-inapp">
      <textarea value={reason} onChange={(e) => setReason(e.target.value)} maxLength={1000} rows={3} placeholder="Neden (isteğe bağlı)"
        className="w-full rounded border border-slate-300 p-2 text-sm" data-testid="deletion-reason-input" />
      <Button onClick={send} disabled={busy} className="bg-rose-600 hover:bg-rose-700" data-testid="deletion-request-submit">Hesabımın silinmesini talep et</Button>
    </div>
  );
}

export default function AccountDeletion() {
  const logged = !!tokens.access();
  return (
    <PublicShell testid="account-deletion-page">
      <h1 className="text-3xl sm:text-4xl font-bold text-slate-900">Hesap Silme</h1>
      <p className="mt-1 text-sm text-slate-500">Account deletion · İMAMOGLU PLUS</p>
      <div className="mt-8 space-y-5 text-sm leading-relaxed">
        <section>
          <h2 className="text-base md:text-lg font-semibold text-slate-900">Nasıl talep edilir?</h2>
          <p>1) Uygulamaya giriş yaptıysanız aşağıdaki düğmeyle (veya mobil uygulamada Profil → Hesabımı Sil) talep oluşturun. 2) Giriş yapamıyorsanız kurumsal e-posta adresinizden <a className="text-blue-700 underline" href={`mailto:${MAIL}?subject=${encodeURIComponent("İMAMOGLU PLUS hesap silme talebi")}`} data-testid="deletion-mailto">{MAIL}</a> adresine “hesap silme talebi” konulu e-posta gönderin.</p>
        </section>
        <section>
          <h2 className="text-base md:text-lg font-semibold text-slate-900">Ne olur?</h2>
          <p>Talep Süper Yönetici tarafından en geç 30 gün içinde incelenir. Onaylandığında: hesabınız kapatılır, tüm oturumlarınız ve cihaz bildirim kayıtlarınız silinir; adınız, e-postanız ve telefonunuz anonimleştirilir.</p>
          <p className="mt-1">Yasal saklama: şirketin sipariş, fatura, cari, tahsilat ve finans kayıtları Vergi Usul Kanunu ve Türk Ticaret Kanunu gereği saklanmak zorundadır; bu kayıtlar silinmez, yalnızca sizi tanımlayan bilgiler anonimleştirilir.</p>
        </section>
        <section className="rounded border border-slate-200 bg-white p-4">
          {logged ? <InAppRequest /> : <p data-testid="deletion-login-hint">Talep oluşturmak için <Link to="/giris" className="text-blue-700 underline">giriş yapın</Link> veya {MAIL} adresine yazın.</p>}
        </section>
      </div>
    </PublicShell>
  );
}
